module.exports = __webpack_public_path__ + "static/media/MothDark_Bookcover.dc117f73.jpg";